var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCallIncomingMissed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71 13.67C20.66 10.77 16.54 9 12 9C7.46 9 3.34 10.77 0.29 13.67C0.11 13.85 0 14.1 0 14.38C0 14.65 0.11 14.9 0.29 15.08L2.77 17.56C2.95 17.74 3.2 17.86 3.5 17.86C3.75 17.86 4 17.75 4.18 17.57C4.97 16.83 5.86 16.21 6.84 15.72C7.17 15.56 7.4 15.22 7.4 14.82V11.72C8.85 11.25 10.39 11 12 11C13.6 11 15.15 11.25 16.6 11.72V14.82C16.6 15.22 16.83 15.56 17.16 15.72C18.14 16.21 19.03 16.83 19.82 17.57C20 17.75 20.25 17.86 20.5 17.86C20.8 17.86 21.05 17.74 21.23 17.56L23.71 15.08C23.89 14.9 24 14.65 24 14.38C24 14.1 23.89 13.85 23.71 13.67ZM6.5 2.5L12 8L19 1L18 0L12 6L7.5 1.5H11V0H5V6H6.5V2.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCallIncomingMissed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/call-incoming-missed.94cb6533b131687610a71afb93f7d30d.svg";